import { render, staticRenderFns } from "./PromotionCreate.vue?vue&type=template&id=60c07784&scoped=true"
import script from "./PromotionCreate.vue?vue&type=script&lang=js"
export * from "./PromotionCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c07784",
  null
  
)

export default component.exports